import * as React from "react";
import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { Slider, SliderProps } from "@progress/kendo-react-inputs";
import { Hint, Error, Label } from "@progress/kendo-react-labels";
import { CgDanger } from "react-icons/cg";
import IconComponent from "../common/IconComponent";

const FormSliderField = (props: SliderProps & FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    min = 0,
    max = 100,
    step = 1,
    optional,
    value,
    onChange,
    wrapperClassName,
    wrapperStyle,
    ...other
  } = props;

  const [tooltipValue, setTooltipValue] = React.useState(value || min);

  const showValidationMessage = touched && validationMessage;
  const showHint = !showValidationMessage && hint;
  const hintId = showHint ? `${id}_hint` : "";
  const errorId = showValidationMessage ? `${id}_error` : "";

  const handleChange = (e: any) => {
    const newValue = Math.round(e.value);
    setTooltipValue(newValue);
    onChange?.({ value: newValue });
  };

  return (
    <FieldWrapper className={wrapperClassName} style={wrapperStyle}>
      <Label
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
        optional={optional}
      >
        {label}
      </Label>

      <div
        style={{
          position: "relative",
          display: "flex",
          width: "100%",
          flexDirection: "column",
          gap: 10,
        }}
      >
        <Slider
          id={id}
          min={min}
          max={max}
          step={step}
          value={tooltipValue}
          defaultValue={min}
          disabled={disabled}
          onChange={handleChange}
          aria-describedby={`${hintId} ${errorId}`}
          style={{ width: "100%", minHeight: 30 }}
          {...other}
        />
        <div
          style={{
            border: "1px solid lightgray",
            height: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "500",
            whiteSpace: "nowrap",
            padding: "0 10px",
            borderRadius: 4,
          }}
        >
          {tooltipValue}
        </div>
      </div>

      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && (
        <Error className="d-flex justify-content-end" id={errorId}>
          <span
            className="d-flex align-items-center"
            style={{
              background: "#DF4957",
              color: "white",
              padding: "1px 8px 1px 5px",
              borderRadius: 10,
              gap: 5,
            }}
          >
            <IconComponent icon={CgDanger} /> {validationMessage}
          </span>
        </Error>
      )}
    </FieldWrapper>
  );
};

export default FormSliderField;
